import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { TwcWizardComponent } from '@topcon/twc-angular';

/**
 * Service to manage the Wizard footer
 */
@Injectable({ providedIn: 'root' })
export class WizardFooterService {
    wizard!: TwcWizardComponent;

    private previousStepClickedSubject$ = new Subject<TwcWizardComponent>();
    private previousStepClicked$ = this.previousStepClickedSubject$.asObservable();
    private nextStepClickedSubject$ = new Subject<TwcWizardComponent>();
    private nextStepClicked$ = this.nextStepClickedSubject$.asObservable();
    private finishClickedSubject$ = new Subject<void>();
    private finishClicked$ = this.finishClickedSubject$.asObservable();
    private closeClickedSubject$ = new Subject<void>();
    private closeClicked$ = this.closeClickedSubject$.asObservable();

    previousClick(): void {
        this.previousStepClickedSubject$.next(this.wizard);
    }

    nextClick(): void {
        this.nextStepClickedSubject$.next(this.wizard);
    }

    finishClick(): void {
        this.finishClickedSubject$.next();
    }

    closeClick(): void {
        this.closeClickedSubject$.next();
    }

    /**
     * Enables subscription to know when previous button has been clicked
     */
    onPrevButtonClick(): Observable<TwcWizardComponent> {
        return this.previousStepClicked$;
    }

    /**
     * Enables subscription to know when next button has been clicked
     */
    onNextButtonClick(): Observable<TwcWizardComponent> {
        return this.nextStepClicked$;
    }

    /**
     * Enables subscription to know when finish wizard button has been clicked
     */
    onFinishButtonClick(): Observable<void> {
        return this.finishClicked$;
    }

    /**
     * Enables subscription to know when close button has been clicked
     */
    onCloseButtonClick(): Observable<void> {
        return this.closeClicked$;
    }
}
